// função de Debounce do Lodash
const debounce = function (func, wait, immediate) {
  let timeout;
  return function () {
    let context = this, args = arguments;
    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

const animaChamada = function animaChamada() {
  const elemento = $('[data-animacao="chamada"]'),
    imagens = $('[data-animacao="imagens"]');

  setTimeout(function () {
    elemento.addClass('animate');

    $.each(imagens, function (i, el) {
      function addAnimation() {
        el.classList.add("animate");
      }

      if (el.classList.value === 'icon-inventivo') {
        setTimeout(addAnimation, 1300);
      } else if (el.classList.value === "icon-relacionamento") {
        setTimeout(addAnimation, 1800);
      } else {
        setTimeout(addAnimation, 2300);
      }
    });

  }, 600);

  $(document).scroll(debounce(function () {
    const topElemento = elemento.offset().top,
      heightElemento = elemento.innerHeight(),
      scrollDoc = $(this).scrollTop();

    if (scrollDoc >= (topElemento + heightElemento)) {
      elemento.addClass('animate-scroll');
    } else {
      elemento.removeClass('animate-scroll');
    }
  }, 200));
};

function animaCasesP() {
  const casesContainer = `[data-animacao="cases"]`,
    caseOne = $(`${casesContainer} .case `),
    caseVideo = $(`${casesContainer} .case video`),
    headerHeigth = $('.menu-site').innerHeight(),
    nextCase = $('[data-vid="click-scroll"]');

    $(document).scroll(debounce(function () {
      let scrollDoc = $(document).scrollTop();   
      caseOne.each(function (i, el) {
        if((scrollDoc + headerHeigth) >= caseOne[i].offsetTop && (scrollDoc + headerHeigth) <= caseOne[i].offsetTop + innerHeight) {
          caseOne[i].childNodes[1].classList.add('animate');
          caseOne.find(caseVideo).get(i).play();
          $(this).off('scroll');
        } else if (true) {      
          caseOne[i].childNodes[1].classList.remove('animate');
        }
      });
    }, 200));


  // Animação para avançar por cada case
  nextCase.each(function (i, el) {
    $(this).click(function (e) {
      e.preventDefault();
      const attrVid = $(this).attr('data-vid-click');
      if (attrVid === 'del-valle') {
        $('html, body').animate({
          scrollTop: $('[data-case-target="mitsubishi"]').offset().top
        }, 900);
      } else if (attrVid === 'mitsubishi') {
        $('html, body').animate({
          scrollTop: $('[data-case-target="pompom"]').offset().top
        }, 900);
      } else if (attrVid === 'pompom') {
        $('html, body').animate({
          scrollTop: $('[data-case-target="royal-canin"]').offset().top
        }, 900);
      } else if (attrVid === 'royal-canin') {
        $('html, body').animate({
          scrollTop: $('[data-case-target="skyn"]').offset().top
        }, 900);
      } else if (attrVid === 'skyn') {
        $('html, body').animate({
          scrollTop: $('[data-case-target="samsung"]').offset().top
        }, 900);
      }
    });
  });
}
let animaCases = animaCasesP;

const animaHeader = function animaHeader() {
  //funcão que muda a altura do menu de acordo com o Scroll
  let bannerHome = $('[data-banner="video"]').innerHeight(),
    menuSite = $('.menu-site');

  //isolando a função de scroll para usar em dois cenários
  function header() {
    let rolagemTop = $(document).scrollTop();
    if (rolagemTop > (bannerHome / 2)) {
      return menuSite.addClass('scroll-menu');
    } else {
      return menuSite.removeClass('scroll-menu');
    }
  };

  //cenário 1: ativa a função mesmo sem dar Scroll na tela quando estiver em outra área do site
  if ($('html, body').scrollTop() > $(window).innerHeight()) {
    header();
  }

  //cenário 2: ativa a função com scroll do mouse
  $(document).scroll(function () {
    header();
  });
}

const menuAumenta = function menuAumenta() {
  let self = $('.menu_hamburguer');
  self.toggleClass('aumenta-menu');
  $('.nav_ul').toggleClass('active');
  $(".first").toggleClass("active");
  $(".second").toggleClass("active");
  $(".third").toggleClass("active");
}

const menuBuble = function menu() {
  let self = $('.menu_hamburguer');
  if ($('.menu_hamburguer .aumenta-menu')) {
    self.removeClass('aumenta-menu');
    $(".first").removeClass("active");
    $(".second").removeClass("active");
    $(".third").removeClass("active");
    $('.nav_ul').removeClass('active');
  }
};